import { styled, Box } from '@mui/system';

export const ExtendableContainer = styled(Box)(() => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: '#ffffff',
}));
